import { render, staticRenderFns } from "./MainError.vue?vue&type=template&id=3c93d4c8&"
import script from "./MainError.vue?vue&type=script&lang=js&"
export * from "./MainError.vue?vue&type=script&lang=js&"
import style0 from "./MainError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports